import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-126fe24c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "navbar",
  class: "navbar navbar-expand-lg bg-white sticky-top"
}
const _hoisted_2 = { class: "container-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Magneto Renewable Energy logo",
  class: "img-fluid"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#Nav",
  "aria-controls": "Nav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse justify-content-end",
  id: "Nav"
}
const _hoisted_6 = { class: "navbar-nav my-3 my-lg-0" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<a class=\"nav-link\" href=\"/#About\" data-v-126fe24c>About</a><hr class=\"d-block d-lg-none\" data-v-126fe24c><a class=\"nav-link\" href=\"/#Solutions\" data-v-126fe24c>Solutions</a><hr class=\"d-block d-lg-none\" data-v-126fe24c><a class=\"nav-link\" href=\"/#Projects\" data-v-126fe24c>Projects</a><hr class=\"d-block d-lg-none\" data-v-126fe24c><a class=\"nav-link\" href=\"/#Partners\" data-v-126fe24c>Partnerships</a><hr class=\"d-block d-lg-none\" data-v-126fe24c>", 8)
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: {name: 'Home'},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollTop()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: {name: 'ResidentialHome'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Residential")
            ]),
            _: 1
          }),
          _hoisted_15,
          _createElementVNode("a", {
            class: "nav-link",
            href: "#footer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeMenu()))
          }, " Contact Us "),
          _hoisted_16
        ])
      ])
    ])
  ]))
}